export const I18N_PREFIX = 'common';
export const LOGIN_TEXT = `${I18N_PREFIX}.login`;
export const LOGIN_TO_SEE_TEXT = `${I18N_PREFIX}.login_to_see`;
